import React from "react";
import "./style.scss";

interface CustomCheckboxProps {
  checked: boolean;
  onChange?: (checked: any) => void;
  type?: "square" | "circle";
  disabled?: boolean;
  label?: string;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  type = "square",
  disabled = false,
  label,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      onChange(e);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <label
        className={`custom-checkbox ${type} ${disabled ? "disabled" : ""}`}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className="checkmark" />
      </label>
      {label && <div className="checkbox-label">{label}</div>}
    </div>
  );
};

export default CustomCheckbox;
